import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import Typography from '@material-ui/core/Typography'
import cn from 'classnames'
import FilterBar from './FilterBar'
import EventList from './EventList'
import EventFormModal from './EventFormModal'
import EventInfoPanel from './EventInfo/SideInfo'
import 'styles/app/apps/logbook.scss'

class Logbook extends Component {
  state = {
    dataFields: [],
    requestParams: {},
    isEventEditable: false,
    isPanelOpen: false,
    isFilterOpen: false,
  }

  componentDidMount() {
    const {
      logbookFilters: { dataFields },
      storeDataFields,
    } = this.props
    const storeDataFieldsArr = storeDataFields.toJS()
    const checkDataFields = storeDataFieldsArr.length
      ? storeDataFieldsArr
      : dataFields
    this.setState({ dataFields: checkDataFields })
  }

  componentDidUpdate(prevProps) {
    const {
      logbookFilters: { dataFields },
      storeDataFields,
    } = this.props
    const storeDataFieldsArr = storeDataFields.toJS()
    const {
      logbookFilters: { dataFields: prevDataFields },
    } = prevProps

    if (!isEqual(dataFields, prevDataFields)) {
      const checkDataFields = storeDataFieldsArr.length
        ? storeDataFieldsArr
        : dataFields
      this.setState({ dataFields: checkDataFields })
    }
  }

  handleFilterOpen = value => {
    this.setState({ isFilterOpen: value })
  }

  handleFieldsChange = fieldsArr => {
    this.setState({ dataFields: fieldsArr })
  }

  onEditEvent = () => {
    this.setState(prevState => {
      const result = {}

      if (prevState.isPanelOpen) {
        result.isEventEditable = true
      } else {
        result.isEventEditable = true
        result.isPanelOpen = true
      }

      return result
    })
  }

  onStopEdit = () => {
    this.setState({ isEventEditable: false })
  }

  getRequestParams = (params = {}) => {
    if (Object.keys(params).length > 0) {
      this.setState({ requestParams: params })
    }
  }

  onTableRowClick = () => {
    if (this.state.isEventEditable) {
      this.setState({
        isEventEditable: false,
      })
    }

    this.setState({
      isPanelOpen: true,
    })
  }

  onPanelClose = () => {
    this.setState({ isPanelOpen: false })
  }

  render() {
    const {
      isPanelOpen,
      requestParams,
      isEventEditable,
      isFilterOpen,
      dataFields,
    } = this.state

    return (
      <div
        className={cn('module logbook-module', {
          'filters-open': isFilterOpen,
        })}>
        <div className="module-head">
          <Typography className="module-title" variant="h5">
            {this.props.currentApp.name}
          </Typography>
          <div className="module-filter">
            <FilterBar
              dataFields={dataFields}
              handleFilterOpen={this.handleFilterOpen}
              handleFieldsChange={this.handleFieldsChange}
              {...this.props}
            />
          </div>
        </div>
        <div
          className={cn('module-content', { 'side-panel-open': isPanelOpen })}>
          <EventList
            onTableRowClick={this.onTableRowClick}
            getQueryParams={this.getRequestParams}
            onEditEvent={this.onEditEvent}
            onClosePanel={this.onPanelClose}
            dataFields={dataFields}
            {...this.props}
          />
          <EventInfoPanel
            open={isPanelOpen}
            isEventEditable={isEventEditable}
            onEditEvent={this.onEditEvent}
            onStopEdit={this.onStopEdit}
            queryParams={requestParams}
            onClose={this.onPanelClose}
          />
          <EventFormModal />
        </div>
      </div>
    )
  }
}

export default connect(state => ({
  isLoadSiteList: state.getIn(['monitorsAndAlerts', 'isLoadSiteList']),
  isLoadLocusList: state.getIn(['monitorsAndAlerts', 'isLoadLocusList']),
  isLocusGroupsLoaded: state.getIn([
    'monitorsAndAlerts',
    'isLocusGroupsLoaded',
  ]),
  logbookFilters: state.getIn(['profile', 'profile', 'logbookFilters']),
  storeDataFields: state.getIn(['logbook', 'dataFields']),
}))(Logbook)
